import { render, staticRenderFns } from "./alert-normal.vue?vue&type=template&id=5c1bf764&lang=pug&"
import script from "./alert-normal.vue?vue&type=script&lang=js&"
export * from "./alert-normal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports